import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  openModal (event) {
    event.preventDefault();
    document.getElementById(event.currentTarget.dataset.modalId).show();
  }
}
